import { useState } from 'react';
import type { FormEvent } from 'react';

import { useSessao } from './SessaoContext';
import './login.css';

export function Login() {
  const { entrar } = useSessao();
  const [email, setEmail] = useState('');
  const [senha, setSenha] = useState('');
  const [erro, setErro] = useState<string | null>(null);
  const [enviando, setEnviando] = useState(false);

  async function enviar(evento: FormEvent) {
    evento.preventDefault();
    setErro(null);
    setEnviando(true);
    try {
      await entrar(email, senha);
    } catch (e) {
      setErro(e instanceof Error ? e.message : 'Não foi possível entrar.');
    } finally {
      setEnviando(false);
    }
  }

  return (
    <main className="login-pagina">
      <form className="login-cartao" onSubmit={enviar}>
        <div className="login-logo">
          <div className="mk">GG</div>
          <div className="tt">
            <b>GG PILOT</b>
            <span>GOYAZ GAMES</span>
          </div>
        </div>

        <label>
          E-mail
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="voce@goyazgames.com"
            autoComplete="username"
            required
          />
        </label>

        <label>
          Senha
          <input
            type="password"
            value={senha}
            onChange={(e) => setSenha(e.target.value)}
            autoComplete="current-password"
            required
          />
        </label>

        {erro && <div className="login-erro">{erro}</div>}

        <button type="submit" disabled={enviando}>
          {enviando ? 'Entrando…' : 'Entrar'}
        </button>

        <p className="login-nota">
          O login com a conta Google corporativa chega junto com a configuração do domínio.
        </p>
      </form>
    </main>
  );
}
